<style scoped>
    @import url("../../styles/smartControl/xilemaSC.scss");
</style>

<template>
    <div class="box_xilemaSC">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-connection</v-icon>
            <span class="ml-2">Integração especial</span>
        </div>

        <!-- INFO ESTRUTURAL -->
        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- INFO USE CASE -->
        <div class="tit2 mt-2" v-if="!flagIEspecial">
            <v-chip class="" color="white">Nenhuma integração especial habilitada neste sistema</v-chip>
        </div>

        <div class="tit2 mt-2" v-if="flagIEspecial">
            <div class="">
                <span>{{ 'Integração: ' }}</span>
                <v-chip class="" color="white">XILEMA REMOTO</v-chip>
            </div>
        </div>

        <div class="painelGeral mt-2" v-if="flagIEspecial">
            <div class="menuBTN">
                <div v-for="(btn,indexA) in liTitulos" 
                :key="indexA" 
                class="elBTN"
                @mouseover="btn.c = '#F39C12'"
                @mouseleave="btn.c = '#F9FAFA'"
                :style="{ background: selectedBTN === indexA ? '#F39C12' : btn.c }"
                @click="openBTN(indexA)"
                >
                    {{ btn.t }}
                </div>
            </div>
        </div>

        <!-- LOADING -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- RECEITAS -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagR">
            <CardReceitaXilema 
            v-for="(r,i) in liReceitas" :key="i"
            :recipe="r"
            @mouseover="r.b = '1px 1px #F39C12'"
            @mouseleave="r.b = '1px 1px black'"
            :style="{'box-shadow':r.b}"
            @click="editRecipe(i)"
            />
        </div>

        <!-- GRUPOS -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagG">
            <CardGrupoXilema 
            v-for="(g,j) in liGrupos" :key="j"
            :group="g"
            @mouseover="g.b = '1px 1px #F39C12'"
            @mouseleave="g.b = '1px 1px black'"
            :style="{'box-shadow':g.b}"
            @click="editGroup(j)"
            />
        </div>

        <!-- PROGRAMAS -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagP">
            <CardProgramaXilema 
            v-for="(p,k) in liProgramas" :key="k"
            :program="p"
            @mouseover="p.b = '1px 1px #F39C12'"
            @mouseleave="p.b = '1px 1px black'"
            :style="{'box-shadow':p.b}"
            @click="editProgram(k)"
            />
        </div>

        <!-- SELEÇÃO DO PINO/PROGRAMA DE ACIONAMENTO -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagU">
            <CardUPINCXilema 
            v-for="(u,w) in liControlUPINC" :key="w"
            :controller="u"
            @mouseover="u.b = '1px 1px #F39C12'"
            @mouseleave="u.b = '1px 1px black'"
            :style="{'box-shadow':u.b}"
            @click="editControlUPINC(w)"
            />
        </div>

        <!-- EDIÇÃO DO PINO/PROGRAMA DE ACIONAMENTO -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagEditU">
            <EDITCardUPINCXilema 
            :controller="selectedControlUPINC"
            :tok="tok"
            />
        </div>

        <!-- RECEITA -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagEditR">
            <EDITCardR 
            :recipe="selectedRecipe"
            :tok="tok"
            />
        </div>

        <!-- GRUPO -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagEditG">
            <EDITCardG 
            :group="selectedGroup"
            :tok="tok"
            />
        </div>

        <!-- PROGRMA -->
        <div class="painelGeral mt-2" v-if="!flagLoading && flagIEspecial && flagEditP">
            <EDITCardP
            :program="selectedProgram"
            :tok="tok"
            />
        </div>

    </div>
</template>

<script>
import axios from 'axios'

import CardReceitaXilema from './subXilema/CardReceitaXilema.vue'
import CardGrupoXilema from './subXilema/CardGrupoXilema.vue'
import CardProgramaXilema from './subXilema/CardProgramaXilema.vue'
import CardUPINCXilema  from './subXilema/CardUPINCXilema.vue'

import EDITCardUPINCXilema from './subXilema/EDITCardUPINCXilema.vue'
import EDITCardR from './subXilema/EDITCardR.vue'
import EDITCardG from './subXilema/EDITCardG.vue'
import EDITCardP from './subXilema/EDITCardP.vue'

export default {

    components:{
        CardReceitaXilema, CardGrupoXilema, CardProgramaXilema, CardUPINCXilema,
        EDITCardUPINCXilema, EDITCardR, EDITCardG, EDITCardP
    },

    data() {
        return {
            // -- estrutura do componente
            flagMsgSistema:false, // permitir exibição após haver sistema habilitado.
            flagLoading:false,

            // -- use cases
            // ---
            flagIEspecial:false, // true ==> existe integração habilitada
            tok:null, // token upinc xilema
            
            // --- 
            selectedBTN:2,
            liTitulos:[
                {'t':'Programas','c':'#F9FAFA'},
                {'t':'Grupos','c':'#F9FAFA'},
                {'t':'Receitas','c':'#F9FAFA'},
                {'t':'Acionamento UPINC','c':'#F9FAFA'}
            ],
            flagR:false,
            flagG:false,
            flagP:false,
            flagU:false,
            liReceitas:[],
            liGrupos:[],
            liProgramas:[],
            liControlUPINC:[],

            selectedControlUPINC:null,
            flagEditU:false,

            selectedRecipe:null,
            flagEditR:false,

            selectedGroup:null,
            flagEditG:false,

            selectedProgram:null,
            flagEditP:false,
        }
    },

    methods:{

        editControlUPINC(indexLiControlUPINC) {
            this.selectedControlUPINC = this.liControlUPINC[indexLiControlUPINC]
            this.flagP = false
            this.flagG = false
            this.flagR = false
            this.flagU = false
            this.flagEditU = true
            this.flagEditR = false
            this.flagEditG = false
            this.flagEditP = false
        },

        editRecipe(indexLiRecipe) {
            this.selectedRecipe = this.liReceitas[indexLiRecipe]
            this.flagP = false
            this.flagG = false
            this.flagR = false
            this.flagU = false
            this.flagEditU = false
            this.flagEditR = true
            this.flagEditG = false
            this.flagEditP = false
        },

        editGroup(indexLiGroup) {
            this.selectedGroup = this.liGrupos[indexLiGroup]
            this.flagP = false
            this.flagG = false
            this.flagR = false
            this.flagU = false
            this.flagEditU = false
            this.flagEditR = false
            this.flagEditG = true
            this.flagEditP = false
        },

        editProgram(indexLiProgram) {
            this.selectedProgram = this.liProgramas[indexLiProgram]
            this.flagP = false
            this.flagG = false
            this.flagR = false
            this.flagU = false
            this.flagEditU = false
            this.flagEditR = false
            this.flagEditG = false
            this.flagEditP = true
        },

        async openBTN(indexA) {
            const flagBool = await this.selectCall(indexA)
            if (flagBool == false) { return }
            //console.log('after')

            this.selectedBTN = indexA
            let c = 0
            while (c < this.liTitulos.length) {
                if (c != indexA) { this.liTitulos[indexA]['c'] = '#F9FAFA' }
                else { this.liTitulos[indexA]['c'] = '#F39C12' }
                c++
            }
        },

        async selectCall(index) {
            let flagBoolReturn = false

            this.flagLoading = true
            const tok = this.tok
            let flagCall = false
            let rotaBranch = null
            let params = {}
            if (index == 0) {
                // PROGRAMAS
                flagCall = true
                rotaBranch = '/readxprogramsxilema'
            }
            if (index == 1) {
                // GRUPOS
                flagCall = true
                rotaBranch = '/readxgroupsxilema'
            }
            if (index == 2) {
                // RECEITAS
                flagCall = true
                rotaBranch = '/readxrecipesxilema'
            }
            if (index == 3) {
                // MATCH UPINC ACTUATOR
                flagCall = true
                params = {
                    "api_client":this.$store.state.emailCliente,
                    "coll":this.$store.state.sistemaSC,
                    "name_key":"identifier",
                    "key_value":"ia_agent_unit",
                    "target_key":"atuadores"
                }
                rotaBranch = '/xadmxreadbyinfofromcl'
            }
            if (flagCall) {
                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Xilema-Auth': `Bearer ${tok}`,
                    'Content-Type': 'application/json'
                }
                let self = this
                const rota = self.$store.state.pathAxiosBASE + rotaBranch
                const res = await axios.post(rota, params, {headers})
                console.log(res.data.result)

                const rcv = res.data.result

                if (index == 3) {
                    if (rcv.ok) {
                        let countControllers = 0
                        for (const atu of rcv.element) {
                            if (atu.telecom == "http_xilema") {
                                self.liControlUPINC = []
                                for (const param of atu.params) {
                                    self.liControlUPINC.push({
                                        't':param.titulo,
                                        'p':param.pino,
                                        'c':countControllers,
                                        'main':structuredClone(rcv.element), // actuators list from target key
                                        'b':'1px 1px black'
                                    })
                                }
                                break
                            }
                            countControllers++
                        }
                        self.flagP = false
                        self.flagG = false
                        self.flagR = false
                        self.flagU = true
                        self.flagEditU = false
                        self.flagEditR = false
                        self.flagEditG = false
                        self.flagEditP = false
                        console.log('self.liControlUPINC: ',self.liControlUPINC)
                        flagBoolReturn = true
                    }
                }
                if (index == 2) {
                    if (rcv.error == false) {
                        for (const recipe of rcv.recipes) {
                            recipe.b = '1px 1px black' // nova key
                        }
                        self.liReceitas = rcv.recipes
                        self.flagP = false
                        self.flagG = false
                        self.flagR = true
                        self.flagU = false
                        self.flagEditU = false
                        self.flagEditR = false
                        self.flagEditG = false
                        self.flagEditP = false
                        flagBoolReturn = true
                    }
                }
                if (index == 1) {
                    if (rcv.error == false) {
                        for (const group of rcv.li_groups) {
                            group.b = '1px 1px black' // nova key
                        }
                        self.liGrupos = rcv.li_groups
                        self.flagP = false
                        self.flagG = true
                        self.flagR = false
                        self.flagU = false
                        self.flagEditU = false
                        self.flagEditR = false
                        self.flagEditG = false
                        self.flagEditP = false
                        flagBoolReturn = true
                    }
                }
                if (index == 0) {
                    if (rcv.error == false) {
                        for (const program of rcv.li_programs) {
                            program.b = '1px 1px black' // nova key
                        }
                        self.liProgramas = rcv.li_programs
                        self.flagP = true
                        self.flagG = false
                        self.flagR = false
                        self.flagU = false
                        self.flagEditU = false
                        self.flagEditR = false
                        self.flagEditG = false
                        self.flagEditP = false
                        flagBoolReturn = true
                    }
                }
                self.flagLoading = false
                return flagBoolReturn
            }
            else {
                return flagBoolReturn
            }
        },
        
        preInit() {

            console.log('test-xilema-integration-preInit')

            let sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025
            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }
            let self = this
            let params = { 'cliente':cl, 'sistema':sistema }
            const rota = self.$store.state.pathAxiosBASE + '/postxuserxcheck'
            axios.post(rota, params, {headers}).then(function (res) {
                //console.log(res.data.result)
                const rcv = res.data.result
                if (rcv.error == false) {
                    if (rcv.user_check) {
                        self.flagIEspecial = true
                        self.tok = rcv.xilema_token
                        self.selectCall(2) // (index_receita_call, sub_token)
                    }
                }
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false
            this.preInit()
        }
        
    }
}
</script>

/*
            liReceitas:[
                {
                    "formula": 10,
                    "name": 'teste nome',
                    "idealEC": '1.3',
                    "relMaxEC": '2.5',
                    "idealPH": '5.4',
                    "relMinPH": '5.0',
                    "phAbsoluteAlarm": '6.0',
                    "ceAbsoluteAlarm": '3.0',
                    "phControl": '',
                    "ECControl": '',
                    "ideal_incremental": '',
                    "fertilizer_0_percentage":0,
                    "fertilizer_1_percentage":0,
                    "fertilizer_2_percentage":0,
                    "fertilizer_3_percentage":0,
                    "fertilizer_4_percentage":0,
                    "fertilizer_5_percentage":0,
                    "fertilizer_6_percentage":0,
                    "fertilizer_7_percentage":0,
                    "fertilizer_8_percentage":0,
                },
                {
                    "formula": 11,
                    "name": 'segundo',
                    "idealEC": '1.1',
                    "relMaxEC": '1.9',
                    "idealPH": '5.4',
                    "relMinPH": '5.0',
                    "phAbsoluteAlarm": '6.0',
                    "ceAbsoluteAlarm": '3.0',
                    "phControl": '',
                    "ECControl": '',
                    "ideal_incremental": '',
                    "fertilizer_0_percentage":0,
                    "fertilizer_1_percentage":0,
                    "fertilizer_2_percentage":0,
                    "fertilizer_3_percentage":0,
                    "fertilizer_4_percentage":0,
                    "fertilizer_5_percentage":0,
                    "fertilizer_6_percentage":0,
                    "fertilizer_7_percentage":0,
                    "fertilizer_8_percentage":0,
                },
                {
                    "formula": 12,
                    "name": 'terceiro',
                    "idealEC": '1.3',
                    "relMaxEC": '2.5',
                    "idealPH": '5.4',
                    "relMinPH": '5.0',
                    "phAbsoluteAlarm": '6.0',
                    "ceAbsoluteAlarm": '3.0',
                    "phControl": '',
                    "ECControl": '',
                    "ideal_incremental": '',
                    "fertilizer_0_percentage":0,
                    "fertilizer_1_percentage":0,
                    "fertilizer_2_percentage":0,
                    "fertilizer_3_percentage":0,
                    "fertilizer_4_percentage":0,
                    "fertilizer_5_percentage":0,
                    "fertilizer_6_percentage":0,
                    "fertilizer_7_percentage":0,
                    "fertilizer_8_percentage":0,
                }
            ]
*/